var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-window-item',{attrs:{"value":_vm.value}},[_c('v-card',{staticClass:"mx-auto",attrs:{"flat":"","light":_vm.light,"color":_vm.color,"max-width":"380","rounded":"xl"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }